import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { useSelector } from 'react-redux';
import { NavMarker } from 'react-rhumb';
import styled from 'styled-components';
import { AnimatedStepBody } from '../animation/StepBodyAnimations';
import { useIsWideStep } from '../hooks/useIsWideStep';
import { useResponsiveness } from '../responsiveness/ResponsivenessProvider';
import { getCurrentStep } from '../store/flow/selectors';
import { devices } from '../styles/viewports.styles';
import { GreetingsPretitle } from '../views-components/GreetingsPretitle';
import { StepSubtitle } from '../views-components/StepSubtitle';
import { StepTitle } from '../views-components/StepTitle';
import { Step } from './Step';
const BaseViewIllustration = styled.div.withConfig({
  displayName: "BaseView__BaseViewIllustration",
  componentId: "sc-3btd5l-0"
})(["width:8.125rem;text-align:center;margin:1.5rem auto;@media ", "{display:none;", "}"], devices.desktop, props => props.isWideStep && `display:block;`);
const BaseViewAnimation = styled.div.withConfig({
  displayName: "BaseView__BaseViewAnimation",
  componentId: "sc-3btd5l-1"
})(["text-align:center;@media ", "{display:none;", "}"], devices.desktop, props => props.isWideStep && `display:block;`);
const BaseViewHeader = styled.header.withConfig({
  displayName: "BaseView__BaseViewHeader",
  componentId: "sc-3btd5l-2"
})(["margin-bottom:1.5rem;", ""], props => props.stepKey === Step.JobRole && `
  @media ${devices.tablet}{
    width: 75%;
  }
  @media ${devices.desktop} {
    width: 90%;
  }
  `);
export const BaseView = ({
  title,
  illustration,
  animation,
  helperText,
  footer,
  children,
  stepKey,
  navMarker,
  preTitleMessage = '',
  addExperimentClassName = false,
  disableAnimation = false
}) => {
  const {
    isMobile
  } = useResponsiveness();
  const currentStep = useSelector(getCurrentStep);
  const step = stepKey || currentStep;
  const {
    isWideStep
  } = useIsWideStep();

  if (!step) {
    return null;
  }

  const stepTitle = /*#__PURE__*/_jsx(StepTitle, {
    stepKey: step
  });

  const navMarkerName = navMarker || `${step}_VIEW`;
  const experimentSeleniumAttribute = addExperimentClassName ? {
    'data-selenium-experiment': 'EXPERIMENT'
  } : null;
  return /*#__PURE__*/_jsxs(AnimatedStepBody, {
    dataStep: step,
    disableAnimation: disableAnimation,
    children: [/*#__PURE__*/_jsx(NavMarker, {
      name: navMarkerName
    }), /*#__PURE__*/_jsxs("div", Object.assign({
      className: "BaseView",
      "data-selenium": `${step}_VIEW`
    }, experimentSeleniumAttribute, {
      children: [/*#__PURE__*/_jsxs(BaseViewHeader, {
        className: "BaseView__Header",
        stepKey: step,
        children: [illustration ? /*#__PURE__*/_jsx(BaseViewIllustration, {
          className: "BaseView__Illustration m-x-auto",
          isWideStep: isWideStep,
          children: illustration
        }) : null, animation && isMobile ? /*#__PURE__*/_jsx(BaseViewAnimation, {
          className: "BaseView__Animation m-x-auto",
          isWideStep: isWideStep,
          children: animation
        }) : null, /*#__PURE__*/_jsx(GreetingsPretitle, {
          preTitleMessage: preTitleMessage
        }), /*#__PURE__*/_jsx(StepSubtitle, {
          message: preTitleMessage
        }), title || stepTitle, helperText]
      }), children, footer]
    }))]
  });
};